import {Role} from '../common/types/role'
import {GQL_RoleFragment} from '../generated/graphql'
import {transformPermission} from './transformPermission'

export const transformRole = (role: GQL_RoleFragment): Role => ({
  id: role.id,
  name: role.name,
  permissions: role.permissions.map(transformPermission),
})
